import { api } from '@/api';
import { GameEnded } from '@/components/shared_ui/GameEnded';
import { useGameEndView, usePlayerState, useStore } from '@/engine/store';
import { createFileRoute } from '@tanstack/react-router';
import { Button } from 'ht-sdk/react';

export const Route = createFileRoute('/game-ended')({
	component: RouteComponent,
});

function RouteComponent() {
	const state = useGameEndView();
	const player = usePlayerState();

	// const textOutlineColor = '#924acfb3';
	// const textOutlineStyle = `[text-shadow:1px_1px_0_${textOutlineColor},-1px_-1px_0_${textOutlineColor},1px_-1px_0_${textOutlineColor},-1px_1px_0_${textOutlineColor}]`;

	if (!state) return null;

	return (
		<GameEnded>
			<Button
				size="md"
				mode="secondary"
				onClick={async () => {
					if (player.id && state.sessionId) {
						await api.eventLogCreate({
							eventType: 'LEAVE_SESSION',
							playerId: player.id,
							sessionId: state.sessionId,
						});
					}
					// TODO: API call to notify the server that we are leaving the game
					// or some mechanism so other tablets can still join as our previous team
					useStore.getState().leaveSession();
					// window.location.reload();
				}}
			>
				Sessie verlaten
			</Button>
		</GameEnded>
	);
}
